<template>
  <div>
    <HeaderView></HeaderView>
    <div class="image-container">
      <!-- Update the image path -->
      <img
        src="/staticImages/banner(vlog).png"
        class="img-fluid h-50"
        alt="Contact Image"
        style="filter: brightness(50%)"
      />
      <div
        class="text-center text-white position-absolute top-50 start-50 translate-middle"
      >
        <h1>VLOG</h1>
        <p>Home > Vlog</p>
      </div>
    </div>

    <div class="container my-5">
      <div class="row" v-for="(data, index) in vlogs" :key="index">
        <div class="col-lg-7 col-12">
          <ul>
            <li>
              <h5 class="my-3 fw-bold">{{ data.title }}</h5>
              <br />
            </li>
          </ul>
          <iframe
            :src="data.path"
            width="560"
            height="315"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>

    <FooterView></FooterView>
  </div>
</template>

<script>
import axios from "axios";
import FooterView from "./Layouts/FooterView.vue";
import HeaderView from "./Layouts/HeaderView.vue";

export default {
  name: "GalleryView",
  components: { HeaderView, FooterView },
  data() {
    return {
      BaseUrl: process.env.VUE_APP_BASE_URL,
      vlogs: [],
    };
  },
  methods: {
    async getAllVlogs() {
      try {
        const response = await axios.get(`${this.BaseUrl}/vlogs`);
        this.vlogs = response.data.data;
        console.log(this.vlogs);
      } catch (error) {
        console.error("Error fetching vlogs:", error);
      }
    },
  },
  mounted() {
    this.getAllVlogs();
    document.title = "Vlog - Mandalay Water Boom";
  },
};
</script>

<style scoped>
@media only screen and (min-device-width: 375px) and (max-width: 1024px) {
  iframe {
    width: 100% !important;
  }
}
</style>
